const ROOT_ELEMENT_ID = 'root';

let activeBlockCount = 0;
let previousBodyOverflow = '';
/** True only when this manager set `body.style.overflow` on the outermost acquire. */
let didSetBodyOverflow = false;

const getRootElement = (): HTMLElement | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  return document.getElementById(ROOT_ELEMENT_ID);
};

const applyInteractionBlock = (): void => {
  const root = getRootElement();
  root?.setAttribute('inert', '');

  if (typeof document === 'undefined') {
    return;
  }

  const currentOverflow = document.body.style.overflow;
  // If something else already locked scroll (e.g. MUI Drawer/Modal), do not take ownership
  // of overflow. Restoring a captured `hidden` after that overlay closes re-locks the page.
  if (currentOverflow === 'hidden') {
    didSetBodyOverflow = false;
    previousBodyOverflow = '';
    return;
  }

  previousBodyOverflow = currentOverflow;
  document.body.style.overflow = 'hidden';
  didSetBodyOverflow = true;
};

const releaseInteractionBlock = (): void => {
  const root = getRootElement();
  root?.removeAttribute('inert');

  if (typeof document === 'undefined' || !didSetBodyOverflow) {
    return;
  }

  document.body.style.overflow = previousBodyOverflow;
  previousBodyOverflow = '';
  didSetBodyOverflow = false;
};

/** Blocks pointer/keyboard interaction for the full app while an async action is in flight. */
export const acquireInteractionBlock = (): (() => void) => {
  activeBlockCount += 1;

  if (activeBlockCount === 1) {
    applyInteractionBlock();
  }

  let released = false;

  return () => {
    if (released) {
      return;
    }

    released = true;
    activeBlockCount = Math.max(0, activeBlockCount - 1);

    if (activeBlockCount === 0) {
      releaseInteractionBlock();
    }
  };
};

/** Test helper */
export const resetInteractionBlockForTests = (): void => {
  activeBlockCount = 0;
  previousBodyOverflow = '';
  didSetBodyOverflow = false;

  const root = getRootElement();
  root?.removeAttribute('inert');

  if (typeof document !== 'undefined') {
    document.body.style.overflow = '';
  }
};
